import script from "./PendingCommitmentPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PendingCommitmentPage.vue?vue&type=script&setup=true&lang=js"

import "./PendingCommitmentPage.vue?vue&type=style&index=0&id=6fcbe85b&scoped=true&lang=css"

import exportComponent from "/home/runner/work/admin_6_0/admin_6_0/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6fcbe85b"]])

export default __exports__